import React from "react";

import { strollersAddReviewUrl, strollersDetailUrl } from "@/mk2/apps/strollers/urls";
import { Link } from "@/mk2/components/Link";
import { url } from "@/mk2/helpers/urls";
import { StrollerBoxWidgetData } from "@/mk2/schemas";

import { StrollerBox } from "./StrollerBox";
import styles from "./StrollerBoxWidget.mscss";

interface OwnProps {
    eshopSaleorProduct: StrollerBoxWidgetData;
}

type Props = OwnProps;

const StrollerBoxWidget: React.FunctionComponent<Props> = ({ eshopSaleorProduct }) => {
    if (!eshopSaleorProduct) {
        return null;
    }

    const detailUrl = url(strollersDetailUrl, { slug: eshopSaleorProduct.slug });

    return (
        <StrollerBox
            className={styles.StrollerBoxWidget}
            title={<Link to={detailUrl}>{eshopSaleorProduct.title}</Link>}
            image={
                <Link to={detailUrl}>
                    <div
                        className={styles.StrollerBoxWidget__imageCounselling}
                        style={{ backgroundImage: `url(${eshopSaleorProduct.photoUrl})` }}
                    />
                </Link>
            }
            strollerSlug={eshopSaleorProduct.slug}
            reviewsCount={eshopSaleorProduct.reviewsCount}
            score={eshopSaleorProduct.reviewsStars}
            addReviewTo={url(strollersAddReviewUrl, { slug: eshopSaleorProduct.slug })}
        />
    );
};

StrollerBoxWidget.displayName = "StrollerBoxWidget";

export default React.memo<Props>(StrollerBoxWidget);
